import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import "./LanguageSelection.scss";

function LanguageSelection() {
  const { i18n } = useTranslation();

  const changeLanguage = (event, lng) => {
    event.preventDefault();
    i18n.changeLanguage(lng);
  };

  function isActive(lang) {
    return i18n.resolvedLanguage === lang ? "active-button" : "inactive-button";
  }

  return (
    <div className="language_buttons">
      <Link className={isActive("de-DE")} onClick={(e) => changeLanguage(e, "de-DE")} to="#">
        DE
      </Link>
      {" | "}
      <Link className={isActive("en")} onClick={(e) => changeLanguage(e, "en")} to="#">
        EN
      </Link>
      {" | "}
      <Link className={isActive("es-ES")} onClick={(e) => changeLanguage(e, "es-ES")} to="#">
        ES
      </Link>
    </div>
  );
}

export default LanguageSelection;
